import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("token"); // or use Context/Redux
  if (!token) {
    return <Navigate to="/" replace />; // redirect to login if not authenticated
  }
  return children;
};

export default ProtectedRoute;
